export default __webpack_public_path__ + "static/media/image_passenger_not_found.5a2fb2a3.jpg";